import React, {PropTypes} from 'react';
import Translate from 'react-translate-component';
import { InvoiceService } from 'frilans-finans';
import { ConfirmModal } from 'components';
import { proxyCounterpart } from '../../scripts/proxyCounterpart';
import moment from 'moment';
import Utils from 'frilans-finans/utils/utils';
import Ellipsis from '../svg/ellipsis';
import ShowMore from './show-more';
import ReviewOrderButton from './review-order-button';
import ReviewOrderModal from '../modal/review-order/review-order-modal';

export class RegisteredOrdersOrderRow extends React.Component {
  static propTypes = {
    invoice: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    removeInvoiceFromState: PropTypes.func.isRequired,
    toggleShowMoreList: PropTypes.func.isRequired,
    resetShowMoreList: PropTypes.func.isRequired,
    showMoreList: PropTypes.object.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      renderConfirmModal: false,
      showModal: false
    };

    this.showMoreList = this.showMoreList.bind(this);
    this.deleteInvoice = this.deleteInvoice.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.renderDeleteAssignmentModal = this.renderDeleteAssignmentModal.bind(this);
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.renderLojaltyInfoModal = this.renderLojaltyInfoModal.bind(this);
    this.toggleInfoModal = this.toggleInfoModal.bind(this);
  }

  componentDidMount () {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount () {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  setWrapperRef (node) {
    this.wrapperRef = node;
  }

  handleClickOutside (event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      if (this.props.showMoreList.invoiceId === this.props.invoice.id) {
        this.props.resetShowMoreList();
      }
    }
  }

  getActivityText (invoiceDates) {
    let hasLaterDates = false;
    let hasPreviousDates = false;

    invoiceDates.forEach(invoiceDate => {
      if (invoiceDate.date >= moment(moment.now()).format('YYYY-MM-DD')) {
        hasLaterDates = true;
      }
      if (invoiceDate.date < moment(moment.now()).format('YYYY-MM-DD')) {
        hasPreviousDates = true;
      }
    });

    if (hasLaterDates) {
      if (hasPreviousDates || invoiceDates.length === 1) {
        return 'ACTIVE_ASSIGNMENT';
      }
      return 'UPCOMNIG_ASSIGNMENT';
    }
    return 'PAST_ASSIGNMENT';
  }

  showMoreList () {
    this.props.toggleShowMoreList(this.props.invoice.id);
  };

  deleteInvoice () {
    this.props.resetShowMoreList();
    this.setState({
      renderDeleteAssignmentModal: true
    });
  }

  closeModal (confirm) {
    if (confirm) {
      InvoiceService.delete(+this.props.invoice.id)
        .then(this.props.removeInvoiceFromState(+this.props.invoice.id))
        .catch(() => {
          this.setState({
            fetchError: true
          });
        });

      this.setState({
        renderDeleteAssignmentModal: false
      });
    } else {
      this.setState({
        renderDeleteAssignmentModal: false
      });
    }
  }

  renderDeleteAssignmentModal () {
    if (this.state.renderDeleteAssignmentModal) {
      return (
        <ConfirmModal
          callback={this.closeModal}
          message={proxyCounterpart('DELETE_INVOICE')}
        />
      );
    }
  }

  renderShowMoreList (showMoreList) {
    if (showMoreList) {
      return <ShowMore
        deleteInvoice={this.deleteInvoice}
        invoiceId={+this.props.invoice.id}
        user={this.props.user}
        showModal={this.toggleInfoModal}
      />;
    }
  }

  renderLojaltyInfoModal () {
    if (this.state.showModal) {
      return <ReviewOrderModal
        close={this.toggleInfoModal}
        invoiceId={+this.props.invoice.id}
        user={this.props.user}
      />;
    }
  }

  toggleInfoModal () {
    this.setState({
      showModal: !this.state.showModal
    });
  }

  render () {
    let showMoreList = this.props.showMoreList.invoiceId === this.props.invoice.id
      ? this.props.showMoreList.show
      : false;

    return (
      <div key={this.props.invoice.id} className='registered-orders-container'>
        <div className='registered-orders-customer'>
          <div className='registered-orders-curtomer-title'>{this.props.invoice.customer.name}</div>
          <Translate
            className='registered-orders-created-at'
            content='CREATED_DATE'
            date={Utils.formatDate(this.props.invoice.createdAt)}
          />
        </div>

        <Translate
          className='registered-orders-activity hide-extremely-tiny-screen'
          content={this.getActivityText(this.props.invoice.invoiceDates)}
        />
        <ReviewOrderButton
          invoice={this.props.invoice}
          user={this.props.user}
          showModal={this.toggleInfoModal}
        />
        <div
          ref={this.setWrapperRef}
          className='registered-orders-more'
        >
          {this.renderShowMoreList(showMoreList)}
          <div onClick={this.showMoreList}>
            <Ellipsis
              colorSchema='primary'
              fill={showMoreList}
            />
          </div>
        </div>
        {this.renderLojaltyInfoModal()}
        {this.renderDeleteAssignmentModal()}
      </div>
    );
  }
}

export default RegisteredOrdersOrderRow;



/** WEBPACK FOOTER **
 ** ./src/components/registered-orders/order-row.js
 **/